/* eslint-disable import/prefer-default-export */
export const contactPageRoutePrefix = '/';
